// extracted by mini-css-extract-plugin
export default {"widgetPlaceholder":"placeholder_widgetPlaceholder__ECaQo"};